import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * `look="encuentro"`: the Alumnia UI 1.2.1 input (`a-input`) — 44 px floor,
 * 16 px text (no zoom on iOS), `line-control` border, 2 px `en-focus` ring,
 * `danger` border when `aria-invalid`. Used through `Field` and `Search` in
 * components/encuentro/ui.
 */
const ENCUENTRO_INPUT =
  'min-h-en-control w-full min-w-0 rounded-en-md border border-en-line-control bg-en-surface px-4 py-2 font-en-sans text-en-body text-en-ink placeholder:text-en-ink-muted outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-solid focus-visible:outline-en-focus aria-invalid:border-en-danger aria-invalid:shadow-[0_0_0_1px_var(--en-danger)] disabled:cursor-not-allowed disabled:opacity-45 [&::-webkit-search-cancel-button]:cursor-pointer'

function Input({
  className,
  type,
  look,
  ...props
}: React.ComponentProps<'input'> & { look?: 'classic' | 'encuentro' }) {
  if (look === 'encuentro') {
    return (
      <input
        type={type}
        data-slot="input"
        data-look="encuentro"
        className={cn(ENCUENTRO_INPUT, className)}
        {...props}
      />
    )
  }
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-ui-accent selection:text-ui-accent-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border file:border-input file:bg-muted file:text-sm file:font-medium file:rounded-sm file:px-3 file:py-1 file:mr-3 file:cursor-pointer hover:file:bg-muted/80 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        className
      )}
      {...props}
    />
  )
}

export { Input }
